import { isAddressValid } from '../../../../util/account';

/**
 * Attemps to split a full name string into all names.
 *
 * @param {string} [name] The full name.
 * @returns {string[]}
 */
const getNames = name => {
  return (name || '').trim().replace(/\s\s+/g, ' ').split(' ');
};

/**
 * Given a full name returns the family name addressing.
 *
 * @param {string} [name] The full name.
 * @returns {string}
 */
export const getAddressFamilyName = name => {
  if (!name) {
    return '';
  }

  const names = getNames(name);
  return `The ${names.pop()} family`;
};

/**
 * Determines whether a user can select a contact to send a Card to.
 *
 * @param {Object} address Any address type element ie ExternalShippingAddress.
 * @returns {boolean}
 */
export const canSendToAddress = address => {
  return isAddressValid(address);
};
